/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Erasure_LabelInputs */

const es_privacy_policy_rights_erasure_label = /** @type {(inputs: Privacy_Policy_Rights_Erasure_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supresion`)
};

const en_privacy_policy_rights_erasure_label = /** @type {(inputs: Privacy_Policy_Rights_Erasure_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erasure`)
};

/**
* | output |
* | --- |
* | "Erasure" |
*
* @param {Privacy_Policy_Rights_Erasure_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_erasure_label = /** @type {((inputs?: Privacy_Policy_Rights_Erasure_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Erasure_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_erasure_label(inputs)
	return en_privacy_policy_rights_erasure_label(inputs)
});
export { privacy_policy_rights_erasure_label as "privacy_policy.rights.erasure_label" }